import { Link } from 'react-router';
import { Card, EmptyState, linkButtonClass } from '../components';
import { CLIENT_NAV } from '../shells/nav';

/**
 * A section that exists but is switched off.
 *
 * Distinct from a 404 on purpose: the address is real, the page is built, and
 * saying "there is nothing here" would be a lie somebody would waste time on.
 * The reason comes from the same `CLIENT_NAV` entry that greys the sidebar
 * item, so the two cannot drift apart.
 */
export function UnavailablePage({ nav, home = '/' }: { nav: string; home?: string }) {
  const item = CLIENT_NAV.flatMap((group) => group.items).find((candidate) => candidate.to === nav);

  return (
    <Card>
      <EmptyState
        title={`${item?.label ?? 'This section'} is switched off`}
        body={
          item?.disabledReason ??
          'This part of the console is not available at the moment. Nothing has gone wrong with your agent.'
        }
        actions={
          <Link to={home} className={linkButtonClass('primary')}>
            Back to the console
          </Link>
        }
      />
    </Card>
  );
}

export default UnavailablePage;
